/**
 * Default layout boot — kept external so jQuery + casper can use defer without blocking HTML parse.
 */
(function () {
  "use strict";

  function onReady(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  onReady(function () {
    if (typeof jQuery === "undefined") return;
    var $ = jQuery;

    (function relocateSectionsBelowHero() {
      var phase = document.querySelector("#hero-frame-section .hero-frame-phase--start");
      var main = document.getElementById("site-main");
      if (!phase || !main) return;
      var allHdrNodes = phase.querySelectorAll(".top-header");
      if (!allHdrNodes.length) return;

      function phaseOuterBlock(el) {
        var cur = el;
        while (cur && cur.parentElement !== phase) {
          cur = cur.parentElement;
        }
        return cur;
      }

      function lastHeaderInOpeningCluster(headers) {
        if (!headers.length) return null;
        var tagged = [];
        for (var t = 0; t < headers.length; t++) {
          var lang = (headers[t].getAttribute("data-yes-lang") || "").trim();
          if (lang === "en" || lang === "ar") tagged.push(headers[t]);
        }
        if (tagged.length) return tagged[tagged.length - 1];
        return headers[headers.length - 1];
      }

      var bilingualLast = lastHeaderInOpeningCluster(
        Array.prototype.slice.call(allHdrNodes, 0, 24)
      );
      if (!bilingualLast) return;
      var tailBlock = phaseOuterBlock(bilingualLast);

      var heroSection = document.getElementById("hero-frame-section");
      var n = tailBlock ? tailBlock.nextElementSibling : null;
      while (n) {
        var next = n.nextElementSibling;
        if (heroSection && heroSection.nextSibling) {
          main.insertBefore(n, heroSection.nextSibling);
        } else {
          main.appendChild(n);
        }
        n = next;
      }
    })();

    (function moveLogoVideoBeforeReviews() {
      var logoSection = document.getElementById("logo-video-section");
      var main = document.getElementById("site-main");
      if (!logoSection || !main) return;

      var currentLang = "en";
      try {
        var saved = localStorage.getItem("yes_site_lang");
        if (saved === "ar") currentLang = "ar";
      } catch (e) { /* localStorage unavailable */ }

      function pickTargetSection() {
        var reviews = document.querySelectorAll(".reviews-card-main, .reviews-container");
        if (reviews.length) {
          var activeWrapperSel = '[data-yes-lang="' + currentLang + '"]';
          var inactiveLang = currentLang === "ar" ? "en" : "ar";
          var inactiveWrapperSel = '[data-yes-lang="' + inactiveLang + '"]';

          for (var i = 0; i < reviews.length; i++) {
            if (reviews[i].closest && reviews[i].closest(activeWrapperSel)) {
              return { el: reviews[i], mode: "before" };
            }
          }
          for (var j = 0; j < reviews.length; j++) {
            if (!reviews[j].closest || !reviews[j].closest(inactiveWrapperSel)) {
              return { el: reviews[j], mode: "before" };
            }
          }
          return { el: reviews[0], mode: "before" };
        }

        var stats = document.querySelectorAll(".stats-section");
        if (stats.length) {
          var activeWrapperSelStats = '[data-yes-lang="' + currentLang + '"]';
          var inactiveLangStats = currentLang === "ar" ? "en" : "ar";
          var inactiveWrapperSelStats = '[data-yes-lang="' + inactiveLangStats + '"]';

          for (var k = 0; k < stats.length; k++) {
            if (stats[k].closest && stats[k].closest(activeWrapperSelStats)) {
              return { el: stats[k], mode: "after" };
            }
          }
          for (var m = 0; m < stats.length; m++) {
            if (!stats[m].closest || !stats[m].closest(inactiveWrapperSelStats)) {
              return { el: stats[m], mode: "after" };
            }
          }
          return { el: stats[stats.length - 1], mode: "after" };
        }

        return null;
      }

      var targetInfo = pickTargetSection();
      if (targetInfo && targetInfo.el && targetInfo.el.parentNode) {
        var anchor = targetInfo.el;
        var langWrapper = anchor.closest && anchor.closest("[data-yes-lang]");
        if (langWrapper && langWrapper.parentNode) {
          anchor = langWrapper;
        }
        if (targetInfo.mode === "before") {
          anchor.parentNode.insertBefore(logoSection, anchor);
        } else {
          anchor.parentNode.insertBefore(logoSection, anchor.nextSibling);
        }
      } else {
        if (logoSection.parentNode !== main) {
          main.appendChild(logoSection);
        }
      }
    })();

    $(".ar-vr").each(function () {
      var el = this;
      if (!el.getAttribute("data-text")) {
        el.setAttribute("data-text", $(el).text().replace(/\s+/g, " ").trim());
      }
    });

    $(".gh-burger").click(function () {
      $("body").toggleClass("gh-head-open");
    });
    $(".gh-mobile-close").click(function () {
      $("body").removeClass("gh-head-open");
    });

    function toggleNavDropdown(item) {
      var button = item.querySelector(".nav-dropdown-items");
      var isOpen = item.classList.toggle("dropdown-open");
      if (button) button.setAttribute("aria-expanded", isOpen ? "true" : "false");
      document.querySelectorAll(".nav-dropdown-item").forEach(function (other) {
        if (other !== item) {
          other.classList.remove("dropdown-open");
          var otherButton = other.querySelector(".nav-dropdown-items");
          if (otherButton) otherButton.setAttribute("aria-expanded", "false");
        }
      });
    }

    document.querySelectorAll(".nav-dropdown-arrow").forEach(function (arrow) {
      arrow.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        var parentItem = arrow.closest(".nav-dropdown-item");
        if (!parentItem) return;
        toggleNavDropdown(parentItem);
      });
    });

    document.querySelectorAll(".nav-dropdown-items").forEach(function (toggle) {
      toggle.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        var parentItem = toggle.closest(".nav-dropdown-item");
        if (!parentItem) return;
        toggleNavDropdown(parentItem);
      });
    });

    $(".gh-content").fitVids();
  });

  function fetchNavmenuList() {
    var apiKey =
      typeof window.__YESS_GHOST_API_KEY === "string" ? window.__YESS_GHOST_API_KEY : "";
    var apiUrl =
      typeof window.__YESS_CUSTOM_API_BASE === "string" ? window.__YESS_CUSTOM_API_BASE : "";
    if (!apiKey || !apiUrl) return;

    var serviceIcons = {
      "Core Service": "/assets/images/nav-icons/core-services.svg",
      "Signal System": "/assets/images/nav-icons/signal-system.svg",
      "AR VR": "/assets/images/nav-icons/ar-vr.svg",
      "Digital Landscape": "/assets/images/nav-icons/digital-landscape.svg",
      "Iot System Provider": "/assets/images/nav-icons/iot-system.svg"
    };

    fetch(
      apiUrl + "?key=" + encodeURIComponent(apiKey) + "&filter=tags:services&include=tags&order=updated_at%20desc"
    )
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        var container = document.getElementById("navmenuServicesList");
        if (!container || !data.posts) return;

        data.posts.forEach(function (singlePost) {
          for (var i = 0; i < singlePost.tags.length; i++) {
            var tag = singlePost.tags[i];
            if (/^service_/.test(tag.name)) {
              var iconPath =
                serviceIcons[singlePost.title] || "/assets/images/nav-icons/core-services.svg";
              var desc = tag.description || "";
              var li = document.createElement("li");
              li.innerHTML =
                '<a class="nav-dropdown-link" href="/' +
                singlePost.slug +
                '">' +
                '<img class="nav-dropdown-icon" loading="lazy" decoding="async" src="' +
                iconPath +
                '" alt="' +
                singlePost.title +
                '">' +
                '<div class="nav-dropdown-text">' +
                '<span class="nav-dropdown-title">' +
                singlePost.title +
                "</span>" +
                (desc ? '<span class="nav-dropdown-desc">' + desc + "</span>" : "") +
                "</div>" +
                "</a>";
              container.appendChild(li);
              break;
            }
          }
        });
      })
      .catch(function (e) {
        console.error("Failed to fetch services nav:", e);
      });
  }

  function scheduleNavFetch() {
    if (typeof window.__YESS_GHOST_API_KEY === "undefined") return;
    if (typeof requestIdleCallback === "function") {
      requestIdleCallback(
        function () {
          fetchNavmenuList();
        },
        { timeout: 2500 }
      );
    } else {
      setTimeout(fetchNavmenuList, 300);
    }
  }

  onReady(function () {
    scheduleNavFetch();
    var h3s = document.querySelectorAll(".discuss-container h3");
    for (var i = 0; i < h3s.length; i++) {
      var h3 = h3s[i];
      if (!h3.querySelector("a") && (!h3.parentNode || h3.parentNode.tagName.toLowerCase() !== "a")) {
        var link = document.createElement("a");
        link.href = "/contact-us";
        link.className = "discuss-h3-link";
        while (h3.firstChild) {
          link.appendChild(h3.firstChild);
        }
        h3.appendChild(link);
      }
    }
  });
})();
